<template>
  <td :class="cellClass">{{ monthValue }}</td>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DataMethods from '../../../utils/DataMethods.js';

  export default {
    name: 'TableCell',
    mixins: [DataMethods],
    props: ['metric', 'monthObj', 'index'],
    computed: {
      ...mapGetters('audiologyKpis', ['yearStart', 'month']),
      monthOffset() {
        return (((this.month - this.yearStart) + 12) % 12) + 1;
      },
      cellClass() {
        return (this.monthOffset === this.index + 1) ? 'kpi-performance-table__month--selected' : '';
      },
      type() {
        return this.metric.type;
      },
      field() {
        return this.metric.field;
      },
      monthValue() {
        return this.formatData(this.monthObj[this.field]);
      }
    },
    methods: {
      formatData(value) {
        // Customize return value depending on metric
        if (this.type == 'money') {
          return this.currency(value, '$');
        } else if (this.type == 'unit') {
          return this.currency(value);
        } else if (this.type == 'percent') {
          return this.round(this.getPercent(value), 2) + '%';
        }
        return value;
      },

      round(number, precision = 0) {
        var shift = function (number, precision, reverseShift) {
          if (reverseShift) {
            precision = -precision;
          }
          var numArray = ("" + number).split("e");
          return +(numArray[0] + "e" + (numArray[1] ? (+numArray[1] + precision) : precision));
        };
        return shift(Math.round(shift(number, precision, false)), precision, true);
      },
    },
  };
</script>

<style scoped>

</style>
